/** Spanish for the ivr area. Keys are the exact English strings the UI renders. */
const ivr = {
  'The payer response does not confirm coverage for the requested service dates.':
    'La respuesta del pagador no confirma la cobertura para las fechas de servicio solicitadas.',
  'This submission could not be matched to your previous attempt. Check the IVR list before submitting again.':
    'No se pudo vincular este env\u00edo con su intento anterior. Revise la lista de IVR antes de volver a enviar.',
  'Why this is not covered': 'Por qué no está cubierto',
  'This plan does not meet MedEffects\u2019 requirement for Original Medicare Part B as the primary payer.':
    'Este plan no cumple con el requisito de MedEffects de tener Medicare Original Parte B como pagador primario.',
  'Why this was rejected': 'Por qué se rechazó',
  'Patient information could not be verified. Check the name and Medicare ID against the card, then submit a corrected IVR. This is not a coverage denial.':
    'No se pudo verificar la información del paciente. Compare el nombre y el ID de Medicare con la tarjeta y envíe una IVR corregida. Esto no es una denegación de cobertura.',
  'The payer could not verify the Medicare ID. Check it against the Medicare card, correct it, and submit a new IVR. This is not a coverage denial.':
    'El pagador no pudo verificar el ID de Medicare. Compárelo con la tarjeta de Medicare, corríjalo y envíe una nueva IVR. Esto no es una denegación de cobertura.',
  'The payer could not verify the patient name. Check it against the Medicare card, correct it, and submit a new IVR. This is not a coverage denial.':
    'El pagador no pudo verificar el nombre del paciente. Compárelo con la tarjeta de Medicare, corríjalo y envíe una nueva IVR. Esto no es una denegación de cobertura.',
  'MedEffects rejected this request. Review the note from MedEffects for the reason and next steps. This is not a coverage denial.':
    'MedEffects rechazó esta solicitud. Revise la nota de MedEffects para conocer el motivo y los próximos pasos. Esto no es una denegación de cobertura.',
  'Automatic rechecks have finished. MedEffects needs to review this result.':
    'Las verificaciones automáticas finalizaron. MedEffects debe revisar este resultado.',
  'This result needs MedEffects review. No automatic recheck is scheduled.':
    'MedEffects debe revisar este resultado. No hay una nueva verificación automática programada.',
  'This verification needs MedEffects review. Do not submit another IVR for this request.':
    'MedEffects debe revisar esta verificación. No envíe otra IVR para esta solicitud.',
  'Automatic follow-up is complete.': 'El seguimiento automático finalizó.',
  'Automatic follow-up finished. MedEffects needs to review this result.':
    'El seguimiento automático finalizó. MedEffects debe revisar este resultado.',
  'An automatic recheck is queued. You do not need to submit again.':
    'Hay una nueva verificación automática en espera. No necesita volver a enviar la solicitud.',
  'Automatic recheck scheduled for {date}. You do not need to submit again.':
    'Nueva verificación automática programada para {date}. No necesita volver a enviar la solicitud.',
  'This IVR changed or needs to be reloaded before review. Your decision was not saved. Reloading the list.':
    'Esta IVR cambió o debe volver a cargarse antes de revisarla. Su decisión no se guardó. Se está actualizando la lista.',
  'This IVR is no longer available. Reloading the list.':
    'Esta IVR ya no está disponible. Se está actualizando la lista.',
  'Enter the 11-character Medicare ID exactly as shown on the card. Check the letters and numbers.':
    'Ingrese el ID de Medicare de 11 caracteres tal como aparece en la tarjeta. Revise las letras y los números.',
  // IVR Details page (pages/IVRDetails.js) - header, search, tabs
  'IVR Details': 'Detalles de IVR',
  'Review, verify and approve order requests from IVR details.':
    'Revise, verifique y apruebe las solicitudes de pedido desde los detalles de IVR.',
  'Submit and track your IVR requests.': 'Envíe y dé seguimiento a sus solicitudes de IVR.',
  'Search IVR details...': 'Buscar detalles de IVR...',
  'New IVR': 'Nuevo IVR',
  'Could not load IVR requests.': 'No se pudieron cargar las solicitudes de IVR.',
  'IVR requests': 'Solicitudes de IVR',
  All: 'Todos',
  'Needs Review': 'Requiere revisión',
  Covered: 'Cubierto',
  'Not Covered': 'No cubierto',
  'Active Medicare Part B': 'Medicare Parte B activo',
  'Medicare Advantage': 'Plan Medicare Advantage',
  Rejected: 'Rechazado',
  Submitted: 'Presentado',

  // List columns, rows, pagination
  'PATIENT NAME': 'NOMBRE DEL PACIENTE',
  'MEDICARE ID': 'ID DE MEDICARE',
  CLINIC: 'CLÍNICA',
  'SUBMITTED BY': 'PRESENTADO POR',
  'DATE SUBMITTED': 'FECHA DE PRESENTACIÓN',
  STATUS: 'ESTADO',
  ACTIONS: 'ACCIONES',
  'No IVR requests found': 'No se encontraron solicitudes de IVR',
  'N/A': 'N/A',
  View: 'Ver',
  'View IVR details': 'Ver detalles de IVR',
  'Delete IVR {id}': 'Eliminar IVR {id}',
  'Delete IVR request': 'Eliminar solicitud de IVR',
  'Showing {first}–{last} of {total}': 'Mostrando {first}–{last} de {total}',
  'Page {page} of {total}': 'Página {page} de {total}',
  Previous: 'Anterior',
  Next: 'Siguiente',

  // IVR details modal
  'Preparing secure link…': 'Preparando enlace seguro…',
  'Why this needs review': 'Por qué requiere revisión',
  'Worth knowing': 'Conviene saber',
  'Additional Info / Additional Payer Info':
    'Información adicional / Información adicional del pagador',
  '(as reported by the payer)': '(según lo informado por el pagador)',
  'Decision made on {date}': 'Decisión tomada el {date}',
  'Document Attached': 'Documento adjunto',
  'Note from MedEffects': 'Nota de MedEffects',
  '(required for Reject)': '(obligatoria para Rechazar)',
  'Add a note explaining your decision...': 'Agregue una nota que explique su decisión...',
  'Enter a note above to reject': 'Ingrese una nota arriba para rechazar',
  Reject: 'Rechazar',
  'Please enter a note explaining why this IVR is being rejected.':
    'Ingrese una nota que explique por qué se rechaza este IVR.',
  'Failed to reject': 'No se pudo rechazar',
  'Failed to update': 'No se pudo actualizar',
  'Insurance Details': 'Detalles del seguro',
  'Medicare ID': 'ID de Medicare',
  'Patient Comments': 'Comentarios del paciente',
  'No comments': 'Sin comentarios',
  'Approval Document': 'Documento de aprobación',
  'Click to open approval document': 'Haga clic para abrir el documento de aprobación',
  'Approval Doc': 'Doc. de aprobación',
  'Attached Documents': 'Documentos adjuntos',
  'Click to open': 'Haga clic para abrir',
  'Doc {n}': 'Doc. {n}',

  // Approval document section (Covered / Not Covered confirmation)
  'Attach Document (optional)': 'Adjuntar documento (opcional)',
  'Attach Document': 'Adjuntar documento',
  'Add a note explaining your decision below. A document is optional.':
    'Agregue abajo una nota que explique su decisión. El documento es opcional.',
  'A document and a note are both optional - you can confirm without either.':
    'El documento y la nota son opcionales: puede confirmar sin ninguno de los dos.',
  'Please attach the document to finalize this request.':
    'Adjunte el documento para finalizar esta solicitud.',
  'Select Document (Optional)': 'Seleccionar documento (opcional)',
  'Select PDF Document': 'Seleccionar documento PDF',
  '(optional)': '(opcional)',
  'Explain why this IVR is not covered...': 'Explique por qué este IVR no está cubierto...',
  'A note is required.': 'Se requiere una nota.',
  Cancel: 'Cancelar',
  'Uploading...': 'Subiendo...',
  Confirm: 'Confirmar',
  'Confirm Covered': 'Confirmar cubierto',
  'Confirm Not Covered': 'Confirmar no cubierto',

  // Review reasons (utils/reviewReasons.js)
  'Medicare Part B not confirmed': 'Medicare Parte B no confirmada',
  'Medicare Advantage plan reported': 'Se informó un plan Medicare Advantage',
  'Medicare is not the primary payer': 'Medicare no es el pagador principal',
  'Active hospice election - DME may be the hospice’s responsibility':
    'Elección activa de cuidados paliativos (hospicio): el DME puede ser responsabilidad del hospicio',
  'QMB (Medicare + Medicaid): bill Medicare as usual. Do not bill the patient for coinsurance or the deductible.':
    'QMB (Medicare + Medicaid): facture a Medicare como de costumbre. No cobre al paciente el coaseguro ni el deducible.',
  'Workers’ comp or liability payer on file':
    'Pagador de compensación laboral o de responsabilidad civil registrado',
  'HMO plan': 'Plan HMO',
  'Payer is not real-time - verify manually':
    'El pagador no responde en tiempo real: verifique manualmente',
  'Payer returned an error': 'El pagador devolvió un error',
  'The payer requested a corrected Medicare ID': 'El pagador solicitó corregir el ID de Medicare',
  'The payer requested a corrected patient name':
    'El pagador solicitó corregir el nombre del paciente',
  'The verification result could not be confirmed. Do not submit another request; MedEffects must review it.':
    'No se pudo confirmar el resultado de la verificación. No envíe otra solicitud; MedEffects debe revisarla.',
  'Payer did not process the request': 'El pagador no procesó la solicitud',
  'Payer returned no coverage status': 'El pagador no devolvió un estado de cobertura',
  'Payer returned an unrecognized coverage status':
    'El pagador devolvió un estado de cobertura no reconocido',
  'Patient demographics did not match the payer’s record':
    'Los datos demográficos del paciente no coinciden con el registro del pagador',
  'Missing or invalid patient information': 'Falta información del paciente o no es válida',

  // New IVR modal (components/NewIVRModal.js)
  'New IVR Request': 'Nueva solicitud de IVR',
  Close: 'Cerrar',
  'Scanning card...': 'Escaneando tarjeta...',
  'Scan Medicare card': 'Escanear tarjeta de Medicare',
  'Could not read the card. Please enter the details manually.':
    'No se pudo leer la tarjeta. Ingrese los datos manualmente.',
  '{message} Please verify the fields below.': '{message} Verifique los campos a continuación.',
  'Scanned - Please verify the fields below.': 'Escaneada. Verifique los campos a continuación.',
  'Card scan failed. Please enter the details manually.':
    'Falló el escaneo de la tarjeta. Ingrese los datos manualmente.',
  'First Name': 'Nombre',
  'Last Name': 'Apellido',
  'Patient first name': 'Nombre del paciente',
  'Patient last name': 'Apellido del paciente',
  '11-character MBI': 'MBI de 11 caracteres',
  'An MBI is 11 characters (letters and numbers).':
    'Un MBI tiene 11 caracteres (letras y números).',
  'Could not load clinics. Please close and reopen to try again - submission is blocked until the clinic list loads.':
    'No se pudieron cargar las clínicas. Cierre y vuelva a abrir para intentarlo de nuevo; el envío está bloqueado hasta que se cargue la lista de clínicas.',
  'No clinics are assigned to you. Contact an administrator before submitting.':
    'No tiene clínicas asignadas. Contacte a un administrador antes de enviar.',
  Clinic: 'Clínica',
  'Select clinic...': 'Seleccione una clínica...',
  Comment: 'Comentario',
  'Additional context for this request...': 'Contexto adicional para esta solicitud...',
  Documents: 'Documentos',
  'Attach Documents (optional)': 'Adjuntar documentos (opcional)',
  'Remove {name}': 'Quitar {name}',
  'Submitting...': 'Enviando...',
  'Submit IVR': 'Enviar IVR',
  'A document failed to upload, so nothing has been submitted. Your attachments are still attached - please try again.':
    'No se pudo subir un documento, por lo que no se envió nada. Sus archivos siguen adjuntos; inténtelo de nuevo.',
  'Failed to submit IVR request': 'No se pudo enviar la solicitud de IVR',
  'Your attachments could not be verified. Please try submitting again to upload the files again.':
    'No se pudieron verificar los archivos adjuntos. Intente enviar la solicitud de nuevo para volver a subir los archivos.',
  'Too many requests in a short time. Please wait a minute and try again.':
    'Demasiadas solicitudes en poco tiempo. Espere un minuto e inténtelo de nuevo.',

  // Server sentences a user of these screens can hit (be-ref: ocr.service.ts, tenancy.util.ts,
  // insurance.service.ts, upload.*, roles.guard.ts)
  "We couldn't read the card clearly. Please retake the photo in good light, or enter the details manually.":
    'No pudimos leer la tarjeta con claridad. Vuelva a tomar la foto con buena luz o ingrese los datos manualmente.',
  "We couldn't find a Medicare number or name on that image. Please retake the photo or enter the details manually.":
    'No encontramos un número de Medicare ni un nombre en esa imagen. Vuelva a tomar la foto o ingrese los datos manualmente.',
  "We couldn't read the Medicare number on that card - please type it in. The name below was read from the card, so check it too.":
    'No pudimos leer el número de Medicare de esa tarjeta; escríbalo. El nombre de abajo se leyó de la tarjeta, así que revíselo también.',
  "We couldn't read the name on that card - please type it in. The Medicare number below was read from the card, so check it too.":
    'No pudimos leer el nombre de esa tarjeta; escríbalo. El número de Medicare de abajo se leyó de la tarjeta, así que revíselo también.',
  'No image received': 'No se recibió ninguna imagen',
  'A clinic is required. Select the clinic this is for.':
    'Se requiere una clínica. Seleccione la clínica a la que corresponde.',
  'You can only submit for clinics assigned to you':
    'Solo puede enviar para las clínicas que tiene asignadas',
  'A clinic account can only submit for its own clinic':
    'Una cuenta de clínica solo puede enviar para su propia clínica',
  'This clinic account is not bound to a clinic - contact an administrator':
    'Esta cuenta de clínica no está vinculada a una clínica; contacte a un administrador',
  'IVR request not found': 'Solicitud de IVR no encontrada',
  'No file uploaded': 'No se subió ningún archivo',
  'Only JPG, PNG, and PDF files are allowed': 'Solo se permiten archivos JPG, PNG y PDF',
  'You do not have permission to access this resource':
    'No tiene permiso para acceder a este recurso',
};

export default ivr;
